/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_OnlineInputs */

const en_booking_online = /** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const es_booking_online = /** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const fr_booking_online = /** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En ligne`)
};

const de_booking_online = /** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

const id_booking_online = /** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online`)
};

/** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */
const ja_booking_online = en_booking_online;

/** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */
const zh_booking_online = en_booking_online;

/** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */
const ar_booking_online = en_booking_online;

/** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */
const it_booking_online = en_booking_online;

/** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */
const ru_booking_online = en_booking_online;

/** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */
const pt_booking_online = en_booking_online;

/** @type {(inputs: Booking_OnlineInputs) => LocalizedString} */
const ko_booking_online = en_booking_online;

/**
* | output |
* | --- |
* | "Online" |
*
* @param {Booking_OnlineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_online = /** @type {((inputs?: Booking_OnlineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_OnlineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_online(inputs)
	if (locale === "es") return es_booking_online(inputs)
	if (locale === "fr") return fr_booking_online(inputs)
	if (locale === "de") return de_booking_online(inputs)
	if (locale === "ja") return ja_booking_online(inputs)
	if (locale === "zh") return zh_booking_online(inputs)
	if (locale === "ar") return ar_booking_online(inputs)
	if (locale === "id") return id_booking_online(inputs)
	if (locale === "it") return it_booking_online(inputs)
	if (locale === "ru") return ru_booking_online(inputs)
	if (locale === "pt") return pt_booking_online(inputs)
	return ko_booking_online(inputs)
});